import { makeAutoObservable, runInAction } from "mobx";

import { isGeoRestrictedFromCookie } from "@src/services/geofence/geoFenceCookie";

const GEO_FENCE_REFRESH_INTERVAL_MS = 15_000;

export class GeoFenceStore {
  isRestricted = false;

  private refreshIntervalId: number | null = null;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  initialize() {
    if (typeof window === "undefined") return;

    this.refreshFromCookie();

    window.addEventListener("focus", this.refreshFromCookie);
    document.addEventListener("visibilitychange", this.onVisibilityChange);
    this.refreshIntervalId = window.setInterval(this.refreshFromCookie, GEO_FENCE_REFRESH_INTERVAL_MS);
  }

  dispose() {
    if (typeof window === "undefined") return;

    window.removeEventListener("focus", this.refreshFromCookie);
    document.removeEventListener("visibilitychange", this.onVisibilityChange);

    if (this.refreshIntervalId !== null) {
      window.clearInterval(this.refreshIntervalId);
      this.refreshIntervalId = null;
    }
  }

  refreshFromCookie() {
    const nextValue = isGeoRestrictedFromCookie();

    runInAction(() => {
      this.isRestricted = nextValue;
    });
  }

  private onVisibilityChange() {
    if (document.visibilityState === "visible") {
      this.refreshFromCookie();
    }
  }
}
